import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

const progressBarAnim = keyframes`
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
`

export default styled('div')`
  animation: ${progressBarAnim};
  animation-duration: ${props => props.duration}s;
  background-color: ${props => props.theme.color.primary.brand};
  height: 9px;
  transform-origin: left center;
  width: 100%;
`
